<template>
  <div class="bg-white px-6 py-4 my-4">
    <div class="flex flex-col w-full">
      <div v-if="!state.edit">
        <div class="mt-4">
          <span class="font-bold">Primary Logo: </span>
          <span>
            <div
              class="border border-solid border-gray-500 w-20 h-20 flex flex-col items-center justify-center"
            >
              <img
                v-if="report_setting?.report_cover_logo"
                :src="'/storage/' + report_setting.report_cover_logo"
              />
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-8 mb-2 fill-black"
                viewBox="0 0 32 32"
              >
                <path
                  d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                  data-original="#000000"
                />
                <path
                  d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                  data-original="#000000"
                />
              </svg>
            </div>
          </span>
        </div>

        <div class="mt-4">
          <span class="font-bold">Secondary Logo: </span>
          <span>
            <div
              class="border border-solid border-gray-500 w-20 h-20 flex flex-col items-center justify-center"
            >
              <img
                v-if="report_setting?.report_footer_logo"
                :src="'/storage/' + report_setting.report_footer_logo"
              />
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-8 mb-2 fill-black"
                viewBox="0 0 32 32"
              >
                <path
                  d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                  data-original="#000000"
                />
                <path
                  d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                  data-original="#000000"
                />
              </svg>
            </div>
          </span>
        </div>

        <div class="mt-4">
          <span class="font-bold">Header Logo: </span>
          <span>
            <div
              class="border border-solid border-gray-500 w-20 h-20 flex flex-col items-center justify-center"
            >
              <img
                v-if="report_setting?.report_header_logo"
                :src="'/storage/' + report_setting.report_header_logo"
              />
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-8 mb-2 fill-black"
                viewBox="0 0 32 32"
              >
                <path
                  d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                  data-original="#000000"
                />
                <path
                  d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                  data-original="#000000"
                />
              </svg>
            </div>
          </span>
        </div>

        <div class="mt-8">
          <button
            class="inline-flex justify-center py-2 px-4 mr-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
            v-on:click="editSettings"
          >
            Edit
          </button>
        </div>
      </div>

      <div v-if="state.edit">
        <form @submit.prevent="store">
          <div class="mt-8 gap-2 flex flex-nowrap">
            <span class="font-bold inline-block w-1/3">Primary Logo: </span>
            <div class="inline-block w-2/3">
              <div class="flex flex-wrap gap-2">
                <div class="order-2 sm:order-1">
                  <label
                    for="uploadFile1"
                    class="bg-gray-800 hover:bg-gray-700 text-white text-sm px-2 py-1.5 text-center outline-none rounded w-36 cursor-pointer block font-[sans-serif]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 mr-2 fill-white inline"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000"
                      />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000"
                      />
                    </svg>
                    Upload
                    <input
                      ref="inputCover"
                      type="file"
                      id="uploadFile1"
                      class="hidden"
                      @change="onFileChange"
                    />
                  </label>

                  <label
                    class="bg-red-600 text-center mt-2 hover:bg-red-700 text-white text-sm px-2 py-1.5 outline-none rounded w-36 cursor-pointer block font-[sans-serif]"
                    @click="removeSetLogo('report_cover_logo')"
                  >
                    <svg
                      class="w-5 mr-2 inline"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#ffffff"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                        <path
                          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                      </g>
                    </svg>
                    Remove logo
                  </label>
                </div>
                <div class="order-1 sm:order-2">
                  <div
                    class="border border-solid border-gray-500 w-20 h-20 flex flex-col items-center justify-center"
                  >
                    <img v-if="state.url" :src="state.url" />
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-8 mb-2 fill-black"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000"
                      />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-red-600" v-if="setting.errors.report_cover_logo">
              {{ setting.errors.report_cover_logo }}
            </div>
          </div>

          <div class="mt-8 gap-2 flex flex-nowrap">
            <span class="font-bold inline-block w-1/3">Secondary Logo: </span>
            <div class="inline-block w-2/3">
              <div class="flex flex-wrap gap-2">
                <div class="order-2 sm:order-1">
                  <label
                    for="uploadFile2"
                    class="bg-gray-800 text-center hover:bg-gray-700 text-white text-sm px-4 py-2.5 outline-none rounded w-36 cursor-pointer block font-[sans-serif]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 mr-2 fill-white inline"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000"
                      />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000"
                      />
                    </svg>
                    Upload
                    <input
                      ref="inputFooter"
                      type="file"
                      id="uploadFile2"
                      class="hidden"
                      @change="onFileChangeFooter"
                    />
                  </label>

                  <label
                    @click="removeSetLogo('report_footer_logo')"
                    class="bg-red-600 text-center mt-2 hover:bg-red-700 text-white text-sm px-2 py-1.5 outline-none rounded w-36 cursor-pointer block font-[sans-serif]"
                  >
                    <svg
                      class="w-5 mr-2 inline"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#ffffff"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                        <path
                          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                      </g>
                    </svg>
                    Remove logo
                  </label>
                </div>
                <div class="order-1 sm:order-2">
                  <div
                    class="border border-solid border-gray-500 w-20 h-20 flex flex-col items-center justify-center"
                  >
                    <img v-if="state.urlFooter" :src="state.urlFooter" />
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-8 mb-2 fill-black"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000"
                      />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-red-600" v-if="setting.errors.report_footer_logo">
              {{ setting.errors.report_footer_logo }}
            </div>
          </div>

          <div class="mt-8 gap-2 flex flex-nowrap">
            <span class="font-bold inline-block w-1/3">Header Logo: </span>
            <div class="inline-block w-2/3">
              <div class="flex flex-wrap gap-2">
                <div class="order-2 sm:order-1">
                  <label
                    for="uploadFile3"
                    class="bg-gray-800 text-center hover:bg-gray-700 text-white text-sm px-4 py-2.5 outline-none rounded w-36 cursor-pointer block font-[sans-serif]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-5 mr-2 fill-white inline"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000"
                      />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000"
                      />
                    </svg>
                    Upload
                    <input
                      ref="inputHeader"
                      type="file"
                      id="uploadFile3"
                      class="hidden"
                      @change="onFileChangeHeader"
                    />
                  </label>

                  <label
                    @click="removeSetLogo('report_header_logo')"
                    class="bg-red-600 text-center mt-2 hover:bg-red-700 text-white text-sm px-2 py-1.5 outline-none rounded w-36 cursor-pointer block font-[sans-serif]"
                  >
                    <svg
                      class="w-5 mr-2 inline"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#ffffff"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                        <path
                          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        ></path>
                      </g>
                    </svg>
                    Remove logo
                  </label>
                </div>
                <div class="order-1 sm:order-2">
                  <div
                    class="border border-solid border-gray-500 w-20 h-20 flex flex-col items-center justify-center"
                  >
                    <img v-if="state.urlHeader" :src="state.urlHeader" />
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-8 mb-2 fill-black"
                      viewBox="0 0 32 32"
                    >
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000"
                      />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-red-600" v-if="setting.errors.report_header_logo">
              {{ setting.errors.report_header_logo }}
            </div>
          </div>

          <div class="mt-8 flex justify-start">
            <div>
              <button
                @click.prevent="cancelEdit"
                class="inline-flex justify-center py-2 px-4 mr-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Cancel
              </button>
            </div>

            <div>
              <button
                type="submit"
                class="inline-flex justify-center py-2 px-4 mr-3 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:border-gray-400 disabled:text-gray-400 disabled:bg-gray-200"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { useForm } from "@inertiajs/inertia-vue3";
import axios from "axios";
import { useToast } from "vue-toastification";
export default {
  props: {
    report_setting: Object,
    organisation: Object,
  },
  setup(props) {
    //state
    const state = reactive({
      url: null,
      urlHeader: null,
      urlFooter: null,
      edit: false,
    });

    const inputCover = ref(null);
    const inputFooter = ref(null);
    const inputHeader = ref(null);

    const toast = useToast();

    //form
    const setting = useForm({
      report_cover_logo: "",
      report_footer_logo: "",
      report_header_logo: "",
      report_zone_label: "",
    });

    onMounted(() => {
      setImagePreviewsURL();
    });

    // remove uploaded logo
    const removeSetLogo = (logo) => {
      if (!props.report_setting[logo]) {
        console.log(inputCover);
        switch (logo) {
          case "report_cover_logo":
            state.url = null;
            setting.report_cover_logo = null;
            inputCover.value.value = "";
            break;

          case "report_footer_logo":
            state.urlFooter = null;
            setting.report_footer_logo = null;
            inputFooter.value.value = "";
            break;

          case "report_header_logo":
            state.urlHeader = null;
            setting.report_header_logo = null;
            inputHeader.value.value = "";
            break;
        }

        return;
      }
      axios
        .delete(
          route("app.organisation.remove-logo", {
            organisation: props.organisation.id,
            toBeRemove: logo,
          })
        )
        .then((response) => {
          props.report_setting.report_cover_logo =
            response.data.report_cover_logo;

          state.url = response.data.report_cover_logo
            ? "/storage/" + response.data.report_cover_logo
            : null;

          props.report_setting.report_footer_logo =
            response.data.report_footer_logo;
          state.urlFooter = response.data.report_footer_logo
            ? "/storage/" + response.data.report_footer_logo
            : null;

          props.report_setting.report_header_logo =
            response.data.report_header_logo;

          state.urlHeader = response.data.report_header_logo
            ? "/storage/" + response.data.report_header_logo
            : null;

          setting.report_zone_label = response.data.report_zone_label;
          setting.report_cover_logo =
            response.data.report_cover_logo != ""
              ? response.data.report_cover_logo
              : null;
          setting.report_footer_logo =
            response.data.report_footer_logo != ""
              ? response.data.report_footer_logo
              : null;
          setting.report_header_logo =
            response.data.report_header_logo != ""
              ? response.data.report_header_logo
              : null;

          toast.success("Logo setting removed successfully!");
        })
        .catch((e) => {
          toast.error(e.response.data);
        });
    };

    const setImagePreviewsURL = () => {
      state.url = props.report_setting.report_cover_logo
        ? "/storage/" + props.report_setting.report_cover_logo
        : null;
      state.urlFooter = props.report_setting.report_footer_logo
        ? "/storage/" + props.report_setting.report_footer_logo
        : null;
      state.urlHeader = props.report_setting.report_header_logo
        ? "/storage/" + props.report_setting.report_header_logo
        : null;
      setting.report_zone_label = props.report_setting.report_zone_label;
    };

    const editSettings = () => {
      state.edit = true;
      setImagePreviewsURL();
    };

    const onFileChange = (e) => {
      const file = e.target.files[0];
      setting.report_cover_logo = file;
      state.url = URL.createObjectURL(file);
    };

    const onFileChangeHeader = (e) => {
      const file = e.target.files[0];
      setting.report_header_logo = file;
      state.urlHeader = URL.createObjectURL(file);
    };

    const onFileChangeFooter = (e) => {
      const file = e.target.files[0];
      setting.report_footer_logo = file;
      state.urlFooter = URL.createObjectURL(file);
    };

    const cancelEdit = () => {
      //reset all state
      state.edit = false;
      state.url = null;
      state.urlHeader = null;
      state.urlFooter = null;

      //reset the form
      setting.reset();
    };

    const store = () => {
      setting.post(
        route("app.organisation.report_setting", props.organisation.id),
        {
          onSuccess: () => {
            state.edit = false;
          },
        }
      );
    };

    return {
      setting,
      state,
      inputCover,
      inputHeader,
      inputFooter,
      removeSetLogo,
      onFileChange,
      onFileChangeFooter,
      onFileChangeHeader,
      cancelEdit,
      store,
      editSettings,
    };
  },
};
</script>
